export default "dfacfd7c57f0790a.png"